module.exports = __webpack_public_path__ + "static/img/boneco_confirmacao.f918259b.svg";